import { createContext } from 'react';

export const ProposalCollapse = createContext<((collapsed: boolean) => void) | null>(null);
